module.exports = __webpack_public_path__ + "static/media/Oompas.af9f7b58.png";